import { Component, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { UserOrderModel } from 'src/app/nutrigenic/models/profile/user-order-model';
import { UserProfileService } from 'src/app/nutrigenic/services/profile/user-profile.service';
import { HomeService } from 'src/app/nutrigenic/services/home/home.service';
import { ResizeDetectionService } from 'src/app/nutrigenic/services/resize-detection.service';
import { Notify } from 'notiflix/build/notiflix-notify-aio';
import { NgxSpinnerService } from 'ngx-spinner';
import { StripeService } from 'ngx-stripe';
import { StripeCardComponent } from 'ngx-stripe';

@Component({
    selector: 'app-my-orders',
    templateUrl: './my-orders.component.html',
    styleUrls: ['./my-orders.component.scss']
})
export class MyOrdersComponent {

    userOrdersResult: any = {
        "total": 0,
        "per_page": 10,
        "last_page": 0,
        "data": [],
        "first_page_url": null,
        "last_page_url": null,
        "next_page_url": null,
        "prev_page_url": null,
        "current_page": 0
    };
    isTablet: boolean = false;
    isMobile: boolean = false;
    isDesktop: boolean = false;
    paymentPopUpVisibility: boolean = false;
    loading: boolean = true;
    stripeTest: FormGroup;
    to_pay: any;

    selectedOrderId: number | null = null;

    constructor(
        private userProfileService: UserProfileService,
        private sizedetection: ResizeDetectionService,
        private fb: FormBuilder,
        private spinner: NgxSpinnerService,
        private router: Router,
        private route: ActivatedRoute,
        private stripeService: StripeService,
        private homeService: HomeService
    ) { }

    ngOnInit() {
        this.stripeTest = this.fb.group({
            name: ['', [Validators.required]]
        });
        this.sizedetection.refreshSize();
        this.sizedetection.sizeCondition$.subscribe(data => {
            this.isDesktop = data.isDesktop;
            this.isTablet = data.isTablet;
            this.isMobile = data.isMobile;
        });

        

        this.getUserOrders();

        this.route.queryParams.subscribe(params => {
            const orderId = params['orderId'];
            this.selectedOrderId = orderId ? parseInt(orderId) : null;
        });
    }

    previousOrders() {
        if (this.userOrdersResult.current_page > 1) {
            this.getUserOrders(this.userOrdersResult.current_page - 1);
        }
    }

    nextOrders() {
        if (this.userOrdersResult.next_page_url != null) {
            this.getUserOrders(this.userOrdersResult.current_page + 1);
        }
    }

    getUserOrders(myOrdersPage: number = 1) {
        let userOrders: UserOrderModel[] = [];
        let userOrdersResultTmp = {
            "total": 0,
            "per_page": 10,
            "last_page": 0,
            "data": userOrders,
            "first_page_url": null,
            "last_page_url": null,
            "next_page_url": null,
            "prev_page_url": null,
            "current_page": 0
        };
        this.spinner.show();
        this.loading = true;
        this.userProfileService.getUserOrders(myOrdersPage).subscribe({
            next: (response: any) => {
                response.body.data.forEach((item: any) => {
                    var userOrder = new UserOrderModel();
                    userOrder.id = item.id;
                    userOrder.order_type = item.order_type;
                    userOrder.order_num = item.order_num;
                    userOrder.order_date = userOrder.GetDate(new Date(item.order_date));
                    userOrder.discount_amount = parseFloat(parseFloat(item.discount_amount).toFixed(2));
                    userOrder.shipment_amount = parseFloat(parseFloat(item.shipment_amount).toFixed(2));
                    userOrder.sub_total = parseFloat(parseFloat(item.subtotal_amount).toFixed(2));
                    userOrder.total_amount = parseFloat(parseFloat(item.total_amount).toFixed(2));
                    userOrder.expert_id = item.expert_id;
                    userOrder.meals_per_day = item.meals_per_day;
                    userOrder.days_per_week = item.days_per_week;
                    userOrder.weeks = item.weeks;
                    userOrder.address = item.address;
                    userOrder.city = item.city;
                    userOrder.zip = item.zip;
                    userOrder.created_at = item.created_at;
                    userOrder.order_detail = item.order_details;
                    userOrder.status = item.status;
                    userOrder.to_pay = item.to_pay;
                    userOrder.weekly_prices = [];
                    userOrder.cancel_from = item.cancel_from ? this.formatDate(new Date(item.cancel_from)) : '';
                    userOrder.auto_renew = item.auto_renew;
                    userOrder.pause_from = item.pause_from ? this.formatDate(new Date(item.pause_from)) : '';
                    userOrder.pause_until = item.pause_until ? this.formatDate(new Date(item.pause_until)) : '';

                    userOrders.push(userOrder);
                });

                userOrders.forEach(order => {
                    let date = new Date(order.order_detail[0].delivery_date);
                    date.setDate(date.getDate() - 3);

                    let nowDate = new Date();
                    nowDate.setHours(0, 0, 0, 0);

                    let order_detail_next = order.order_detail.filter((x: any) => {
                        let deliveryDate = new Date(x.delivery_date);
                        deliveryDate.setDate(deliveryDate.getDate() - 3);
                        return deliveryDate.getTime() > nowDate.getTime();
                    });

                    if (order_detail_next.length > 0 && order.order_type !== 'expert') {
                        var edit_weeks = order_detail_next.filter((x: any) => new Date(x.delivery_date).getTime() > date.getTime());
                        order.edit_week = edit_weeks[0].week;
                    }
                });

                userOrders = userOrders.sort(function (a, b) {
                    return new Date(b.created_at).getTime() - new Date(a.created_at).getTime();
                });

                userOrdersResultTmp.data = userOrders;
                userOrdersResultTmp.total = response.body.total;
                userOrdersResultTmp.per_page = response.body.per_page;
                userOrdersResultTmp.last_page = response.body.last_page;
                userOrdersResultTmp.first_page_url = response.body.first_page_url;
                userOrdersResultTmp.last_page_url = response.body.last_page_url;
                userOrdersResultTmp.next_page_url = response.body.next_page_url;
                userOrdersResultTmp.prev_page_url = response.body.prev_page_url;
                userOrdersResultTmp.current_page = response.body.current_page;
                this.userOrdersResult = userOrdersResultTmp;

                this.loading = false;
                this.spinner.hide();
            },
            error: (error) => {
                console.error(error);
                this.spinner.hide();
                this.loading = false;
            }
        });
    }

    formatDate(dateS: Date) {
        let date = new Date(dateS);
        return (date.getDate().toString().length == 1 ? ("0" + date.getDate().toString()) : date.getDate().toString()) + "." + ((date.getMonth() + 1).toString().length == 1 ? ("0" + (date.getMonth() + 1).toString()) : (date.getMonth() + 1).toString()) + "." + date.getFullYear().toString();
    }

    @ViewChild(StripeCardComponent) card: StripeCardComponent;
    cardOptions: any = {
        hidePostalCode: true,
        disableLink: true,
        style: {
            base: {
                iconColor: '#666EE8',
                color: '#31325F',
                fontWeight: '300',
                fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
                fontSize: '18px',
                '::placeholder': {
                    color: '#CFD7E0',
                },
            },
        },
    };

    elementsOptions: any = {
        locale: 'en-GB',
        appearance: {
            theme: 'flat',
        }
    };

    openPayment(item: any) {
        this.to_pay = item;
        this.paymentPopUpVisibility = true;
    }

    handleSuccessRefresh() {
        this.userOrdersResult.data = [];
        this.getUserOrders();
    }

    openDetails(id: number) {
        this.router.navigate([], { queryParams: { orderId: id }, queryParamsHandling: 'merge' });
    }

    closeOrderDetails() {
        this.router.navigate([], { queryParams: { orderId: null }, queryParamsHandling: 'merge' });
    }

    pay() {
        if (this.stripeTest.valid) {
            this.spinner.show();
            this.createPaymentIntent(parseFloat(this.to_pay.amount)).pipe(
                switchMap((pi: any) =>
                    this.stripeService.confirmCardPayment(pi.body.client_secret, {
                        payment_method: {
                            card: this.card.element,
                            billing_details: { name: this.stripeTest.get('name')?.value, },
                        },
                    })
                )
            ).subscribe({
                next: (result: any) => {
                    if (result.error) {
                        this.spinner.hide();
                        this.handleErrorStripe(result.error.message);
                    } else {
                        if (result.paymentIntent.status === 'succeeded') {
                            let external_order_id = result.paymentIntent.id;
                            this.homeService.repeatOrderPayment({ order_id: this.to_pay.order_id, external_order_id: external_order_id, from: 'My Orders' }).subscribe((res: any) => {
                                this.spinner.hide();
                                console.log(res);
                                this.paymentPopUpVisibility = false;
                                localStorage.removeItem('planOrderDetails');
                                localStorage.removeItem('orderDetails');
                                localStorage.removeItem('cart');
                                localStorage.removeItem('addons');
                                localStorage.removeItem('promo_code');
                                localStorage.removeItem('promo_discount');
                                this.handleSuccessResponse('Payment Successful');
                            });
                        } else this.spinner.hide();
                    }
                }, error: (error) => {
                    console.error(error);
                    this.spinner.hide();
                }
            });
        } else if (!this.stripeTest.valid) this.handleErrorFields();
    }

    createPaymentIntent(amount: number): Observable<any> {
        return this.homeService.createPaymentIntent({ amount: amount * 100 });
    }

    handleError(error: any): void {
        if (error && error.type && error.type === 'validation') {
            let errors = error.message;
            Object.entries(errors).forEach(([_key, value]) => {
                const msg = (value as string[])[0];
                Notify.failure(msg, { position: 'right-top', timeout: 3000 });
            });
        } else {
            const msg = error?.message ?? 'Internal error - Could not complete the operation';
            Notify.failure(msg, { position: 'right-top', timeout: 3000 });
        }
    }

    handleSuccessResponse(message: string = 'Operation Successful'): void {
        this.userOrdersResult.data = [];
        this.getUserOrders();
        Notify.success(message, { position: 'right-top', timeout: 3000 });
    }

    handleErrorFields(): void {
        Notify.failure('Insert all required fields', { position: 'right-top', timeout: 3000 });
    }

    handleErrorStripe(error: any): void {
        Notify.failure(error, { position: 'right-top', timeout: 3000 });
    }
}
